import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/template',
  title: window.language['menu.program.template'],
  component: dynamicWrapper(app, 
    [
      import('../../Material/Material/model'), 
      import('../../System/Org/model'), 
      import('../../System/SysConfig/model'), 
      import('../../HomePage/model'), 
      import('./model')
    ], 
    () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/Program/Template/index.js